import { useMemo } from 'react';
import { SUPPORTED_MAINNET_CHAIN_IDS } from '../constants';
import { useActiveWeb3React } from './web3/use-active-web3-react';

export function useIsMainnet(): boolean | undefined {
  const { chainId } = useActiveWeb3React();
  return useMemo(() => (chainId ? SUPPORTED_MAINNET_CHAIN_IDS.includes(chainId as any) : undefined), [chainId]);
}
